import { Box, styled, Typography } from "@mui/material";
import React from "react";

const RefundPolicy = ({ modal = false }) => {
  const Heading = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "28px" : "32px",
    fontFamily: "Montserrat",
    fontWeight: 700,
    lineHeight: "40px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "16px !important" : "18px !important",
    },
  }));

  const Subheading = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "14px" : "16px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    lineHeight: modal ? "18px" : "22px",
    textAlign: "justify",
    padding: "8px 0",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "12px !important" : "14px !important",
    },
  }));

  const Para = styled(Typography)(({ theme }) => ({
    fontSize: modal ? "12px" : "14px",
    fontFamily: "Montserrat",
    fontWeight: 500,
    lineHeight: modal ? "18px" : "22px",
    textAlign: "justify",
    margin: modal ? "4px 0" : "8px 0",
    marginLeft: "36px",
    [theme.breakpoints.down("sm")]: {
      fontSize: modal ? "10px !important" : "12px !important",
      marginLeft: "16px",
    },
  }));

  return (
    <Box sx={{ bgcolor: modal ? "#FFFFFF" : "#F7F7F7" }}>
      <Box
        sx={{
          mx: { xs: 0, md: 5 },
          bgcolor: "#FFFFFF",
          px: { xs: 4, md: 5 },
          py: { xs: 6, md: 3 },
        }}
      >
        <Heading>Withdraw and Refund Policy</Heading>

        <Para sx={{ fontWeight: 500, fontSize: { xs: "14px", md: "16px" } }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </Para>

        <Subheading>I. Withdrawal</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer at
          posuere purus. Nam dapibus, leo at dignissim molestie, nibh lorem
          vehicula sem, ac efficitur nunc lorem vitae ipsum.
        </Para>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut a erat non
          est aliquam finibus. Fusce pellentesque placerat arcu, non mattis lacus
          luctus non.
        </Para>

        <Subheading>II. Cancellation</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ornare
          sodales lorem, sit amet tincidunt mi volutpat id. Aenean vel dolor
          purus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
          posuere cubilia curae.
        </Para>

        <Subheading>III. Refund</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
          facilisis, velit at suscipit porta, velit elit posuere lacus, id
          laoreet mi lacus vel leo. Donec tempus magna sit amet lacus cursus,
          vitae pulvinar justo convallis.
        </Para>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
          fringilla, mauris eget varius ultricies, neque odio iaculis nibh,
          eleifend consectetur orci ante ut lorem.
        </Para>

        <Subheading>IV. Contact and Resolution</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras feugiat
          ullamcorper ex, quis imperdiet mauris imperdiet id. Etiam a mi ac nibh
          gravida sagittis ac et leo.
        </Para>

        <Subheading>V. Eligibility for Refund Requests</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut
          perspiciatis unde omnis iste natus error sit voluptatem accusantium
          doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo
          inventore veritatis et quasi architecto beatae vitae dicta sunt
          explicabo.
        </Para>
        <Para>
          Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
          fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem
          sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor
          sit amet, consectetur, adipisci velit.
        </Para>

        <Subheading>VI. Refund Timeline</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis autem vel
          eum iure reprehenderit qui in ea voluptate velit esse quam nihil
          molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas
          nulla pariatur.
        </Para>
        <Para>
          At vero eos et accusamus et iusto odio dignissimos ducimus qui
          blanditiis praesentium voluptatum deleniti atque corrupti quos dolores
          et quas molestias excepturi sint occaecati cupiditate non provident.
        </Para>

        <Subheading>VII. Non-Refundable Situations</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Similique sunt
          in culpa qui officia deserunt mollitia animi, id est laborum et dolorum
          fuga. Et harum quidem rerum facilis est et expedita distinctio.
        </Para>
        <Para>
          Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil
          impedit quo minus id quod maxime placeat facere possimus, omnis voluptas
          assumenda est, omnis dolor repellendus.
        </Para>

        <Subheading>VIII. Refund Request Process</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Temporibus
          autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe
          eveniet ut et voluptates repudiandae sint et molestiae non recusandae.
        </Para>
        <Para>
          Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis
          voluptatibus maiores alias consequatur aut perferendis doloribus
          asperiores repellat.
        </Para>

        <Subheading>IX. Escalation and Final Decision</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad
          minima veniam, quis nostrum exercitationem ullam corporis suscipit
          laboriosam, nisi ut aliquid ex ea commodi consequatur.
        </Para>
        <Para>
          Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse
          quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo
          voluptas nulla pariatur.
        </Para>

        <Subheading>X. Policy Updates</Subheading>
        <Para>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sit amet
          sem vitae lacus dictum varius. Curabitur consectetur, massa at
          ullamcorper sagittis, arcu lectus tempor justo, sit amet luctus augue
          est in neque.
        </Para>
      </Box>
    </Box>
  );
};

export default RefundPolicy;
